export const EDITOR_PROPERTIES_REGEXP = /{([\S]+?)}/g

export const FIND_PROPERTIES_IN_TEXT_REGEX = /(\{.*?\})/g

export const CHECK_PROPERTY_STRING_REGEX = /^\{.*?\}/

export const CURLY_BRACES_REGEXP = /[{}]+/g
